import { Accordion, AccordionTab } from "primereact/accordion";
import { useState, useEffect, useRef } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { ProgressSpinner } from "primereact/progressspinner";
import { Menu } from "primereact/menu";
import { Dialog } from "primereact/dialog";
import { ConfiguracionFactorEmpresa } from "./ConfiguracionFactorEmpresa";

export const ConfiguracionEmpresaCliente = ({ permss, generic, toast, catalogo, opcion, tipo }) => {

    const [activeIndex, setActiveIndex] = useState(null);
    const monitoreoService = new MonitoreoService();
    const [info, setInfo] = useState(null);
    const [load, setLoad] = useState(false);
    const [total, setTotal] = useState(0);
    const [empresa, setEmpresa] = useState(null);
    const [listaAreas, setListaAreas] = useState([]);
    const [areaNegocio, setAreaNegocio] = useState(null);
    const [loadingAreas, setLoadingAreas] = useState(false);
    const menu = useRef(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dialogFactores, setDialogFactores] = useState(false);
    const ordenesSinCatalogos = [8];
    const ordenesSinPonderacion = tipo === "RIESGO_CLIENTE" ? [22] : tipo === "RIESGO_PROVEEDOR" ? [7] : [];

    useEffect(() => {
        if (!catalogo?.empresas || catalogo.empresas.length !== 1) return;
        const empresaUnica = catalogo.empresas[0];
        setEmpresa(empresaUnica);
        if (tipo !== 'RIESGO_PROVEEDOR') {
            consultarAreasNegocio(empresaUnica);
        }
    }, []);

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const handleTabChange = (e) => {
        setInfo(null);
        if (e.index === null) {
            setActiveIndex(null);
            return;
        }
        setActiveIndex(e.index);
        consultar(e.index);
    };

    const consultarAreasNegocio = (empresaSeleccionada) => {
        if (!empresaSeleccionada?.cat_id) return;
        setEmpresa(empresaSeleccionada);
        if (tipo === 'RIESGO_PROVEEDOR') { setAreaNegocio(null); return; }
        setLoad(true);
        setLoadingAreas(true);
        monitoreoService.consultar(empresaSeleccionada.cat_id, 'administracion/empresa-areas')
            .then(res => {
                const lista = res.data;
                setListaAreas(lista);
                if (lista.length === 1) {
                    setAreaNegocio(lista[0]);
                    consultar(null, lista[0], empresaSeleccionada);
                } else if (lista.length > 1) {
                    setAreaNegocio(null);
                } else {
                    setAreaNegocio(null);
                }
            })
            .catch(error => {
                generic.funcDeleteError(error, toast);
            })
            .finally(() => {
                setLoad(false);
                setLoadingAreas(false);
            });
    };

    const consultar = (inx = null, area = null, emp = null) => {
        if (tipo !== 'RIESGO_PROVEEDOR') {
            if (area) {
                setAreaNegocio(area);
            } else if (areaNegocio) {
                area = areaNegocio;
            }
        }

        if (emp) {
            setEmpresa(emp);
        } else if (empresa) {
            emp = empresa;
        }
        if ((inx === null || inx === undefined) && (activeIndex === null || activeIndex === undefined)) {
            return;
        }
        //const index = ((inx ?? activeIndex) - 1) + "/" + (area?.cat_id ?? 0) + "/" + (emp?.cat_id ?? 0) + "/" + tipo;
        const index = (inx ?? activeIndex) + "/" + (area?.cat_id ?? 0) + "/" + (emp?.cat_id ?? 0) + "/" + tipo;
        setLoad(true);
        monitoreoService.consultar(index, 'matriz/configuracion/lista').then(res => {
            setInfo(res.data.lista);
            setTotal(res.data.total);
        }).catch(error => {
            generic.funcErrorHibrida(error, toast);
            setActiveIndex(null);
        }).finally(() => {
            setLoad(false);
        });
    }

    const construirData = (newData) => {
        const data = { ...newData, opcion: activeIndex, tipo, area: areaNegocio?.cat_id ?? null };
        if (siOpcion('RIESGO_CLIENTE-LISTA-EMPRESA') || siOpcion('RIESGO_PROVEEDOR-LISTA-EMPRESA')) {
            data.empresa_id = empresa?.cat_id ?? null;
        }
        return data;
    };

    const onRowEditComplete = (e) => {
        const { newData, index } = e;
        const data = construirData(newData);
        setLoad(true);
        monitoreoService.editar(data, 'matriz/configuracion/editar-configuracion').then(res => {
            generic.funcSuccess(res, toast);
            const updated = [...info];
            updated[index] = newData;
            setInfo(updated);
            setTotal(res.data);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoad(false);
        });
    }

    const textEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value)} minFractionDigits={2} maxFractionDigits={5} />
    };

    const actionBodyTemplate = (rowData) => {
        if (ordenesSinCatalogos.includes(rowData.orden_asignado)) {
            return null; // No renderiza nada
        }
        return (
            <Button icon="pi pi-ellipsis-v" rounded className="mr-2" severity="secondary" onClick={(event) => { setSelectedRow(rowData); menu.current.toggle(event); }} aria-controls="popup_menu" aria-haspopup />
        );
    };

    const getFooter = () => {
        const sinPonderacion = info?.some(item => ordenesSinPonderacion.includes(item.orden_asignado));
        if (sinPonderacion) {
            return null;
        }
        return `Total ponderación: ${total}%`;
    };

    const itemsMenu = [
        {
            label: 'Opciones',
            items: [
                {
                    label: 'Editar Factores asociados', icon: 'pi pi-pencil', command: () => { setDialogFactores(true); }
                }
            ]
        }
    ];

    const table = () => {
        if (load) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                    <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                </div>
            );
        }
        const sinPonderacion = info?.some(item => ordenesSinPonderacion.includes(item.orden_asignado));
        return (
            <DataTable value={info} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete} tableStyle={{ width: '100%' }} footer={getFooter()} loading={load}>
                <Column field="nombre" header="Nombre" style={{ width: '50%' }}></Column>
                {!sinPonderacion && <Column field="ponderacion" header="Ponderación" editor={(options) => textEditor(options)} style={{ width: '20%' }}></Column>}
                {!sinPonderacion && <Column header="Editar" rowEditor style={{ width: '15%' }}></Column>}
                <Column header="Acciones" body={actionBodyTemplate} exportable={false} style={{ width: '15%' }}></Column>
            </DataTable>
        );
    }

    // Se debe renderizar dinamicamente para controlar el índice
    const tabsConfig = [
        { key: "FACTORES", header: `Factores de riesgo - ${tipo === 'RIESGO_CLIENTE' ? 'CLIENTE' : 'PROVEEDOR'}`, mostrar: true },
        { key: "OPERACION", header: "Factores de riesgo - OPERACIÓN", mostrar: tipo === 'RIESGO_CLIENTE' },
        { key: "TRANSACCION", header: "Factores de riesgo - TRANSACCIÓN", mostrar: tipo === 'RIESGO_CLIENTE' },
        { key: "SENALES", header: "Factores de riesgo - SEÑALES DE ALERTA", mostrar: true }
    ];

    return (
        <>
            <Menu model={itemsMenu} popup ref={menu} id="popup_menu" />
            <Dialog header="Factores asociados a configuración" visible={dialogFactores} style={{ width: '800px' }} modal onHide={() => setDialogFactores(false)} >
                {selectedRow && empresa && (
                    <ConfiguracionFactorEmpresa factorSeleccionado={selectedRow} empresa={empresa} areaNegocio={areaNegocio} tipo={tipo} toast={toast} generic={generic} />
                )}
            </Dialog>
            <br />
            <div className="formgrid grid align-items-center justify-content-center">
                {(siOpcion('RIESGO_CLIENTE-LISTA-EMPRESA') || siOpcion('RIESGO_PROVEEDOR-LISTA-EMPRESA') || (catalogo?.empresas?.length > 1)) &&
                    <div className="field col-6 p-1" style={{ width: '220px' }}>
                        <b>EMPRESA</b>
                        <Dropdown options={catalogo?.empresas} value={empresa} onChange={(e) => { setActiveIndex(null); setInfo(null); setAreaNegocio(null); setTotal(0); consultarAreasNegocio(e.value); }}
                            optionLabel="nombre" placeholder="Seleccione una empresa" />
                    </div>
                }
                {tipo !== 'RIESGO_PROVEEDOR' && (
                    <div className="field col-6 p-1" style={{ width: '220px' }}>
                        {loadingAreas ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="6" />
                            </div>
                        ) : (
                            listaAreas?.length > 0 && (
                                <>
                                    <b>AREA DE NEGOCIO</b>
                                    <Dropdown options={listaAreas} value={areaNegocio} onChange={(e) => consultar(null, e.value)} optionLabel="nombre" placeholder="Seleccione una área" />
                                </>
                            )
                        )}
                    </div>
                )}
            </div>
            <Accordion activeIndex={activeIndex} onTabChange={handleTabChange} style={{ width: '100%' }}>
                {tabsConfig.filter(tab => tab.mostrar).map((tab, index) => (
                    <AccordionTab key={index} header={tab.header}>
                        {table()}
                    </AccordionTab>
                ))}
            </Accordion>
        </>
    )
}
